import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import IconButton from "@mui/material/IconButton";

import AddLinkIcon from "@mui/icons-material/AddLink";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import CreateNewFolderOutlinedIcon from "@mui/icons-material/CreateNewFolderOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VideoLibraryOutlinedIcon from "@mui/icons-material/VideoLibraryOutlined";

import { finderContextMenuPaperProps } from "./finderStyles";

function FinderMenu({
    open,
    position,
    onClose,
    ariaLabel,
    children,
}) {
    return (
        <Menu
            keepMounted
            open={open}
            onClose={onClose}
            PaperProps={finderContextMenuPaperProps}
            MenuListProps={{ "aria-label": ariaLabel }}
            anchorReference="anchorPosition"
            anchorPosition={open ? position : undefined}
        >
            {children}
        </Menu>
    );
}

function ActionIcon({ children }) {
    return (
        <ListItemIcon sx={{ minWidth: "36px !important" }}>
            {children}
        </ListItemIcon>
    );
}

export function FinderRowActionButton({ label, onClick }) {
    return (
        <IconButton
            aria-label={label}
            onClick={onClick}
            size="small"
            sx={{
                display: { xs: "inline-flex", sm: "none" },
                width: 36,
                height: 36,
                ml: "auto",
                mr: -0.5,
                flexShrink: 0,
                color: "inherit",
                backgroundColor: "action.hover",
                border: "1px solid",
                borderColor: "divider",
                "&:hover": {
                    backgroundColor: "action.selected",
                },
            }}
        >
            <MoreVertIcon fontSize="small" />
        </IconButton>
    );
}

export function FinderAddMenu({ open, position, onClose, onAction }) {
    return (
        <FinderMenu
            open={open}
            position={position}
            onClose={onClose}
            ariaLabel="Add to folder"
        >
            <MenuItem onClick={() => onAction("newfolder")}>
                <ActionIcon>
                    <CreateNewFolderOutlinedIcon fontSize="small" />
                </ActionIcon>
                New folder
            </MenuItem>
            <MenuItem onClick={() => onAction("newfile")}>
                <ActionIcon>
                    <UploadFileOutlinedIcon fontSize="small" />
                </ActionIcon>
                Upload files
            </MenuItem>
            <MenuItem onClick={() => onAction("newlink")}>
                <ActionIcon>
                    <AddLinkIcon fontSize="small" />
                </ActionIcon>
                Add link
            </MenuItem>
        </FinderMenu>
    );
}

export function FinderFileContextMenu({
    open,
    position,
    onClose,
    onAction,
    canShare,
    canManage = true,
    showPlaylistsAndTimelines = false,
}) {
    return (
        <FinderMenu
            open={open}
            position={position}
            onClose={onClose}
            ariaLabel="File actions"
        >
            {showPlaylistsAndTimelines && (
                <MenuItem
                    onClick={() => onAction("playlistsandtimelines")}
                >
                    <ActionIcon>
                        <VideoLibraryOutlinedIcon fontSize="small" />
                    </ActionIcon>
                    Playlists and Timelines
                </MenuItem>
            )}
            {canManage && (
                <>
                    {canShare && (
                        <MenuItem onClick={() => onAction("sharefile")}>
                            <ActionIcon>
                                <ShareOutlinedIcon fontSize="small" />
                            </ActionIcon>
                            Share to Hub
                        </MenuItem>
                    )}
                    <MenuItem onClick={() => onAction("renamefile")}>
                        <ActionIcon>
                            <DriveFileRenameOutlineIcon fontSize="small" />
                        </ActionIcon>
                        Rename
                    </MenuItem>
                    <MenuItem onClick={() => onAction("duplicatefile")}>
                        <ActionIcon>
                            <ContentCopyOutlinedIcon fontSize="small" />
                        </ActionIcon>
                        Duplicate
                    </MenuItem>
                    <MenuItem
                        onClick={() => onAction("deletefile")}
                        sx={{
                            color: "error.main",
                            "& .MuiListItemIcon-root": {
                                color: "error.main",
                            },
                        }}
                    >
                        <ActionIcon>
                            <DeleteOutlineIcon fontSize="small" />
                        </ActionIcon>
                        Delete
                    </MenuItem>
                </>
            )}
        </FinderMenu>
    );
}

export function FinderFolderContextMenu({
    open,
    position,
    onClose,
    onAction,
    isHub,
}) {
    return (
        <FinderMenu
            open={open}
            position={position}
            onClose={onClose}
            ariaLabel={isHub ? "Hub actions" : "Folder actions"}
        >
            {isHub ? (
                <MenuItem onClick={() => onAction("edithub")}>
                    <ActionIcon>
                        <EditOutlinedIcon fontSize="small" />
                    </ActionIcon>
                    Edit Hub
                </MenuItem>
            ) : (
                <MenuItem onClick={() => onAction("renamefolder")}>
                    <ActionIcon>
                        <DriveFileRenameOutlineIcon fontSize="small" />
                    </ActionIcon>
                    Rename folder
                </MenuItem>
            )}
            <MenuItem onClick={() => onAction("archive")}>
                <ActionIcon>
                    <ContentCopyOutlinedIcon fontSize="small" />
                </ActionIcon>
                Copy for Archive Utility
            </MenuItem>
            {!isHub && (
                <MenuItem
                    onClick={() => onAction("deletefolder")}
                    sx={{
                        color: "error.main",
                        "& .MuiListItemIcon-root": { color: "error.main" },
                    }}
                >
                    <ActionIcon>
                        <DeleteOutlineIcon fontSize="small" />
                    </ActionIcon>
                    Delete folder
                </MenuItem>
            )}
        </FinderMenu>
    );
}
